'use strict';
import React from 'react';
import flux from 'utils/flux';
import ReactZeroClipboard from 'react-zeroclipboard';

var ShareModal = React.createClass({
    displayName: 'ShareModal',
    propTypes: {
        shareUrl: React.PropTypes.object
    },
    getInitialState() {
        return {
            copied: false
        };
    },
    onCopy() {
        this.setState({copied: true});
    },
    onFocus(e) {
        e.target.disabled || e.target.select();
    },
    renderSuccess() {
        if (this.state.copied) {
            return (
                <span className="copy__success">{flux.t('copied')}</span>
            );
        }
    },
    render() {
        let sharedURL = this.props.shareUrl || flux.t('share_wait');
        let flashAvailable = false;
        try {
            flashAvailable = Boolean( new ActiveXObject('ShockwaveFlash.ShockwaveFlash') );
        } catch(exception) {
            flashAvailable = ( 'undefined' != typeof navigator.mimeTypes['application/x-shockwave-flash'] );
        }
        return (
            <div>
                <h4>{flux.t('copy-share-url')}</h4>
                <p>{flashAvailable ? flux.t('copy_instructions') : flux.t('copy_instructions_no_copy_button')}</p>
                <form>
                    <input type="text" readOnly="true" disabled={this.props.shareUrl ? false : true} value={sharedURL} onFocus={this.onFocus} />
                </form>
                {flashAvailable && <ReactZeroClipboard text={sharedURL} onAfterCopy={this.onCopy}>
                    <button className="btn btn-primary btn-copy">{flux.t('copy_to_clipboard')}</button>
                </ReactZeroClipboard>}
                <button onClick={flux.getActions('modals').closeModals} className="btn btn-secondary">{flux.t('cancel')}</button>
                {flashAvailable && this.renderSuccess()}
            </div>
        );
    }
});

module.exports = ShareModal;



// WEBPACK FOOTER //
// ./app/components/modals/shareModal.jsx